module.exports = __webpack_public_path__ + "img/mail.829f5ed5.svg";